// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dropdown-item.active[data-v-a973acfc] {\n    background-color: #272b30;\n}\n", ""]);
// Exports
module.exports = exports;
